import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { CalculateTour } from '../entities/calculate-tour.entity';

type Params = {
  projectId: number;
};

export const getImpactCalculateTourForProject = createAppAsyncThunk(
  'impactCalculateTour/getImpactCalculateTourForProject',
  async (
    params: Params,
    { extra: { impactCalculateTourGateway, snackbarGateway } },
  ): Promise<CalculateTour> => {
    try {
      return await impactCalculateTourGateway.getTourResultsForProject(
        params.projectId,
      );
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetImpactCalculate.Message.error'));
}
